import { getCommodityBidDetailRows } from '@/services/commoditybidIntegration';

export default function CommodityBidItemDetails({ item, compact = false }) {
  const rows = getCommodityBidDetailRows(item);
  if (rows.length === 0) return null;

  if (compact) {
    return (
      <p className="mt-1 text-xs text-slate-500 line-clamp-2">
        {rows.map((r) => `${r.label}: ${r.value}`).join(' · ')}
      </p>
    );
  }

  return (
    <dl
      className="mt-4 grid grid-cols-1 gap-x-6 gap-y-3 border-t border-slate-100 pt-4 sm:grid-cols-2"
      data-testid={`commoditybid-details-${item.kind}-${item.id}`}
    >
      {rows.map(({ label, value }) => (
        <div key={label} className="min-w-0">
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-400">{label}</dt>
          <dd className="mt-0.5 text-sm text-slate-800 break-words">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
